import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { colors } from '@guryou/colors';
import { Block, Button, FlexColumn, FlexRow, FullScreenSpinner, MediumText, TextBox } from '@guryou/html-components';
import { createReservationAsAnonymous, stateIsLoading } from '@guryou/redux';
import { addMinutes, printDate, printInputDate, printPrice, printTime } from '@guryou/utils';

const Popup = ({ subservice, optionSelected, dispatch }) => {
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useState({
    name: '',
    email: '',
    surname: '',
    phone: '',
  });

  const getInputToState = (inputField, value) => {
    const newUserInfo = userInfo; // create new state object

    userInfo[inputField] = value; // Change th value

    setUserInfo(newUserInfo); // Set new state
  };

  const reservationState = useSelector(state => state.reservations.create);

  const reserveClick = onlyBook => {
    dispatch(
      createReservationAsAnonymous({
        subServiceId: subservice.id,
        dateTimeFrom: `${printInputDate(optionSelected.date)}T${optionSelected.time}`,
        email: userInfo.email,
        firstname: userInfo.name,
        phone: userInfo.phone,
        resourceId: optionSelected.resourceId,
        lastname: userInfo.surname,
        onlyBook,
      })
    );
  };

  const addedMinutesTime = addMinutes(`${printInputDate(optionSelected.date)}T${optionSelected.time}`, subservice.duration);

  return (
    <FlexRow backgroundColor={colors.white}>
      {stateIsLoading(reservationState) && <FullScreenSpinner />}
      <FlexRow justifyContent="space-between">
        <FlexColumn alignItems="center">
          <MediumText fontSize={'0.8rem'} fontWeight={400}>
            {t('GENERAL.date')}
          </MediumText>
          <MediumText fontSize={'1.2rem'} fontWeight={400} margin-bottom={15}>
            {printDate(optionSelected.date)}
          </MediumText>
          <MediumText fontSize={'0.8rem'} fontWeight={400}>
            {`${t('GENERAL.price')} ${t('GENERAL.total')}`}
          </MediumText>
          <MediumText fontSize={'1.2rem'} fontWeight={400}>
            {printPrice(subservice.price)}
          </MediumText>
        </FlexColumn>

        <FlexColumn alignItems="center">
          <MediumText fontSize={'0.8rem'} fontWeight={400}>
            {t('SERVICES.startTime')}
          </MediumText>
          <MediumText fontSize={'1.2rem'} fontWeight={400} margin-bottom={15}>
            {printTime(optionSelected.time)}
          </MediumText>
          <MediumText fontSize={'0.8rem'} fontWeight={400}>
            {t('GENERAL.duration')}
          </MediumText>
          <MediumText fontSize={'1.2rem'} fontWeight={400}>
            {subservice.duration}
          </MediumText>
        </FlexColumn>

        <FlexColumn alignItems="center">
          <MediumText fontSize={'0.8rem'} fontWeight={400}>
            {t('SERVICES.endTime')}
          </MediumText>
          <MediumText fontSize={'1.2rem'} fontWeight={400} margin-bottom={15}>
            {printTime(addedMinutesTime)}
          </MediumText>
          <MediumText fontSize={'0.8rem'} fontWeight={400}>
            {t('GENERAL.priceModel')}
          </MediumText>
          <MediumText fontSize={'1.2rem'} fontWeight={400}>
            {subservice.type}
          </MediumText>
        </FlexColumn>
      </FlexRow>

      <FlexRow justifyContent="space-around" alignItems="center">
        <Block xs={5}>
          <TextBox name="name" label={t('GENERAL.name')} onChange={name => getInputToState('name', name)} />
        </Block>
        <Block xs={5}>
          <TextBox name="email" label={t('GENERAL.email')} onChange={email => getInputToState('email', email)} />
        </Block>
      </FlexRow>

      <FlexRow justifyContent="space-around" alignItems="center">
        <Block xs={5}>
          <TextBox name="surname" label={t('GENERAL.surname')} onChange={surname => getInputToState('surname', surname)} />
        </Block>
        <Block xs={5}>
          <TextBox name="phone" label={t('GENERAL.phone')} onChange={phone => getInputToState('phone', phone)} />
        </Block>
      </FlexRow>

      <FlexRow display="flex" justifyContent="center">
        <Button backgroundColor={colors.mandy} color={colors.white} onClick={() => reserveClick(true)}>
          {t('NEWSLETTER.subscribe')} {printPrice(subservice.price)}
        </Button>
        <Button backgroundColor={colors.mandy} color={colors.white} onClick={() => reserveClick(false)}>
          {t('GENERAL.payNow')} {printPrice(subservice.price)}
        </Button>
      </FlexRow>
    </FlexRow>
  );
};
export default Popup;
